var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{staticClass:"mt-4",attrs:{"xs12":"","sm7":"","md5":"","lg4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-card-text',[_c('v-form',[_vm._v("\n           "+_vm._s(this.translate(_vm.messageid))+"\n        ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }